import React, { useState } from "react";
import axios from "axios";
import "../assets/contact.css";

const Git: React.FC = () => {
  const BASE = import.meta.env.VITE_LYRAZONE_BASE_URL;

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      setLoading(true);

      const response = await axios.post(`${BASE}/contact`, formData);

      alert(
        response.data.message || "Your message has been sent successfully.",
      );

      setFormData({
        name: "",
        email: "",
        mobile: "",
        subject: "",
        message: "",
      });
    } catch (error: any) {
      console.error("Contact form error:", error);
      alert(
        error?.response?.data?.message ||
          "Failed to send message. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="overlay-contact-h"></div>

      <section id="contact-h" className="bg-parallax contact-h-bg">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="contact-h-cont">
                <h2 className="cl-white" style={{ textAlign: "center" }}>
                  Get In Touch
                </h2>
                <br />

                <form onSubmit={handleSubmit}>
                  <div className="form-group cl-white">
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Your Name"
                      required
                    />
                  </div>

                  <div className="form-group cl-white">
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Email"
                      required
                    />
                  </div>

                  <div className="form-group cl-white">
                    <input
                      type="tel"
                      className="form-control"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      placeholder="Mobile Number"
                      required
                    />
                  </div>

                  <div className="form-group cl-white">
                    <input
                      type="text"
                      className="form-control"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      placeholder="Subject"
                      required
                    />
                  </div>

                  <div className="form-group cl-white">
                    <textarea
                      className="form-control"
                      style={{ fontSize: "11px", height: "110px" }}
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows={3}
                      placeholder="Write your message here ..."
                      required
                    ></textarea>
                  </div>

                  <button
                    className="btn btn-general btn-silver"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? "SENDING..." : "SYNC UP NOW"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Git;
